import {
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import React from "react"
import AddIcon from "@mui/icons-material/Add"
import EditIcon from "@mui/icons-material/Edit"
import SetClassName from "../modals/SetClassName"

const Timetable = ({ timings, schedule, setClassName, disabled }) => {
  const days = ["MON", "TUE", "WED", "THU", "FRI", "SAT"]
  let tableCols = [" ", ...timings]
  let tableRows = schedule.map((day, i) => [days[i], ...day])
  return (
    <>
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {tableCols.map((timing) => (
                  <TableCell
                    sx={{
                      borderRight: "1px solid silver",
                      textAlign: "center",
                    }}
                  >
                    <b>{timing}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((day, i) => (
                <TableRow key={i}>
                  {day.map((period, j) => (
                    <Period
                      day={j === 0 ? period : ""}
                      data={period}
                      setName={(name) => setClassName(i, j - 1, name)}
                      disabled={disabled}
                    />
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box sx={{ display: { sm: "none" } }}>
        {schedule.map((day, i) => (
          <Grid container sx={{ my: 4 }}>
            <Grid item xs={2}>
              <Typography
                sx={{
                  color: "gray",
                  fontWeight: 600,
                  fontSize: 15,
                  textAlign: "center",
                }}
              >
                {days[i][0] + days[i].slice(1).toLowerCase()}
              </Typography>
            </Grid>
            <Grid item xs={10}>
              <Stack gap={2}>
                {day.map((period, j) => (
                  <MobilePeriod
                    data={period}
                    setName={(name) => setClassName(i, j, name)}
                    timing={timings[j]}
                    disabled={disabled}
                  />
                ))}
              </Stack>
            </Grid>
          </Grid>
        ))}
      </Box>
    </>
  )
}

const Period = ({ day, data, setName, disabled }) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  return (
    <TableCell
      sx={{
        borderRight: "1px solid silver",
        textAlign: "center",
        background:
          data?.name?.toLowerCase() === "break" ? "rgba(0,0,0,0.1)" : "#fff",
      }}
    >
      {day ? (
        <b>{day}</b>
      ) : (
        <>
          <Stack alignItems={"center"} sx={{ fontWeight: 700, fontSize: 16 }}>
            {data.name || (
              <span style={{ color: "gray", fontWeight: 400, fontSize: 12 }}>
                Not set
              </span>
            )}

            {!disabled && !(data?.name === "BREAK") && (
              <IconButton onClick={() => setModalOpen(true)}>
                {data.name ? <EditIcon /> : <AddIcon />}
              </IconButton>
            )}
          </Stack>
          {!disabled && (
            <SetClassName
              isOpen={modalOpen}
              close={() => setModalOpen(false)}
              setName={setName}
            />
          )}
        </>
      )}
    </TableCell>
  )
}

const MobilePeriod = ({ data, setName, timing, disabled }) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  return (
    <Stack
      sx={{
        background:
          data?.name?.toLowerCase() === "break" ? "rgba(0,0,0,0.1)" : "#fff",
        borderRadius: 2,
        py: 1,
        px: 2,
      }}
    >
      <Stack
        direction="row"
        alignItems={"center"}
        justifyContent="space-between"
        sx={{ fontWeight: 600 }}
      >
        {data?.name || (
          <span style={{ color: "gray", fontWeight: 400, fontSize: 12 }}>
            Not set
          </span>
        )}
        {!disabled && !(data?.name === "BREAK") && (
          <IconButton onClick={() => setModalOpen(true)}>
            {data.name ? <EditIcon /> : <AddIcon />}
          </IconButton>
        )}
      </Stack>
      <Typography variant="subtitle2">{timing}</Typography>
      {!disabled && (
        <SetClassName
          isOpen={modalOpen}
          close={() => setModalOpen(false)}
          setName={setName}
        />
      )}
    </Stack>
  )
}

export default Timetable
